import { modalTexts } from "./localization"

// Shown over the overlay while the modal chunk loads. Deliberately not a
// skeleton: modal sizes differ, so a shaped placeholder would jump on mount.
export function CenterSpinner() {
  return (
    <div
      role="status"
      aria-busy
      aria-live="polite"
      className="pointer-events-none fixed inset-0 z-1200 flex items-center justify-center"
    >
      <span className="size-10 animate-spin rounded-full border-2 border-white/20 border-t-white" />
      <span className="sr-only">{modalTexts.loading}</span>
    </div>
  )
}
